import React, { useEffect, useState } from "react";
import DTOTeamReviews from "./DTOTeamReviews";
import TeamReviewsPresenter from "./TeamReviewsPresenter";

import { useTranslation } from "react-i18next";
function TeamReviewsController() {
  const { t } = useTranslation();

  return (
    <div>
      <DTOTeamReviews />
      <TeamReviewsPresenter trans={t} />
    </div>
  );
}

export default TeamReviewsController;
